module.exports = __webpack_public_path__ + "static/media/masthead.167646d7.png";